import setCookie from './functions/_cookie-setCookie-server.js' // Cookie発行（サーバーサイド）
import getCookie from './functions/_cookie-getCookie.js' // Cookie取得

/* global hUrl */
const cookiePath = hUrl + '?update_cookie=1' // cookie制御パス

// debugPopup(
//   'nowLang: ' + getCookie('nowLang') + '<br>googtrans: ' + getCookie('googtrans') + '<br>Cookie: ' + document.cookie
// )

window.addEventListener('click', function (e) {
  // 指定のクラスを持つ
  if (!e.target.classList.contains('js-langShift')) {
    return
  }

  const lang = e.target.dataset.lang
  const nextLang = lang !== 'ja' ? '/ja/' + lang : ''

  setLang(lang, nextLang) // 言語Cookie設定

  const wait = setInterval(() => {
    // Cookieが正常にセットされたらリロード
    // debugPopup(
    //   'nowLang: ' + getCookie('nowLang') + '<br>googtrans: ' + getCookie('googtrans') + '<br>Cookie: ' + document.cookie
    // )
    if (getCookie('nowLang') === lang) {
      clearInterval(wait)
      // Google翻訳のハッシュを付ける
      let url = location.href
      url = url.replace(location.hash, '')
      // location.href = url + '#googtrans(ja|' + lang + ')'

      location.reload()
    }
  }, 100)
})

// 言語Cookie設定
function setLang(lang, nextLang) {
  // Google翻訳用のCookieを設定
  // if (lang === 'ja') {
  //   // 日本語ならCookieを消す
  //   setCookie('googtrans', '', cookiePath, -60) // Cookie発行
  // } else {
  //   setCookie('googtrans', nextLang, cookiePath, 60 * 60 * 24 * 360) // Cookie発行
  // }
  // サイトのフラグ用のCookieを設定
  setCookieLocal('nowLang', lang, 60 * 60 * 24 * 360) // 暫定的にローカルでCookie発行
  setCookieLocal('googtrans', nextLang, cookiePath, 60 * 60 * 24 * 360) // 暫定的にローカルでCookie発行
  setCookie('nowLang', lang, cookiePath, 60 * 60 * 24 * 360) // サーバーから正式にCookie発行
  setCookie('googtrans', nextLang, cookiePath, 60 * 60 * 24 * 360) // Cookie発行
}

function setCookieLocal(key, val, maxAge = 60 * 60 * 24 * 7, secure = true, path = '/', sameSite = 'lax', other = '') {
  let setData =
    key + '=' + encodeURIComponent(val) + ';max-age=' + maxAge + ';path=' + path + ';samesite=' + sameSite + other
  if (secure) {
    setData += ';secure'
  }
  document.cookie = setData
}

function debugPopup(text) {
  let popup = document.getElementById('debug-popup')
  if (!popup) {
    popup = document.createElement('div')
    popup.id = 'debug-popup'
    popup.style.position = 'fixed'
    popup.style.right = '5px'
    popup.style.bottom = '5px'
    popup.style.maxWidth = '100%'
    popup.style.maxHeight = '100px'
    popup.style.overflow = 'scroll'
    popup.style.zIndex = '1000000'
    popup.style.padding = '10px'
    popup.style.fontSize = '10px'
    popup.style.background = 'rgba(255,255,255,.9)'
    popup.style.border = '1px solid #000'
    popup.style.cursor = 'pointer'
    document.body.appendChild(popup)
  }

  popup.innerHTML = text
}

//   ####  #####             ##        ###    ##     ##   ####
//  ##     ##  ##            ##       ## ##   ####   ##  ##
//   ###   #####   ########  ##      ##   ##  ##  ## ##  ##  ###
//     ##  ##                ##      #######  ##    ###  ##   ##
//  ####   ##                ######  ##   ##  ##     ##   ####

// SP時は言語プルダウンをタップ式にする

const langPulldown = document.getElementById('langPulldown')
if (langPulldown) {
  document.getElementById('langPulldown-open').addEventListener('click', function (e) {
    if (window.matchMedia('(max-width:768px)').matches) {
      langPulldown.classList.toggle('active')
    }
  })
}
